import { instance } from "api/apiBase";

export const getPropertyPresigned = async (file: File, sessionKey: string) => {
  const queryParams = new URLSearchParams({
    session_key: sessionKey,
    size: file.size.toString(),
    filename: file.name,
    type: file.type
  }).toString();

  const { data } = await instance(
    `/portal/v1/listings/assets/presign?${queryParams}`
  );

  return data;
};
